export const invertRecord = <A extends keyof any, B extends keyof any>(
  record: Record<A, B>,
): Record<B, A> =>
  (Object.entries(record) as [A, B][]).reduce<Record<B, A>>(
    (acc, [key, value]: [A, B]) => {
      if (value in acc) {
        throw new Error('Duplicate value in input object');
      }
      acc[value] = key;
      return acc;
    },
    {} as Record<B, A>,
  );
